'use client';
// Job-type chips for the pro page (04/11/26). Optional cap: first N chips + a real "עוד N" / "פחות" toggle (state, aria-expanded).
import { useState } from 'react';
import Link from 'next/link';

export type ServiceChip = { k: string; name: string; href: string | null };

export default function ProServiceChips({ items, cap }: { items: ServiceChip[]; cap?: number }) {
  const [open, setOpen] = useState(false);
  const capped = !!cap && items.length > cap + 1; // never hide a single chip behind a button
  const shown = capped && !open ? items.slice(0, cap) : items;
  const st = { background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', minHeight: 30, display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' } as const;
  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: '8px 0 0', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {shown.map((s) => (
        <li key={s.k} style={{ flex: '0 0 auto' }}>
          {s.href
            ? <Link href={s.href} className="text-xs px-2.5 py-1 rounded-full font-medium underline-offset-2 hover:underline" style={st}>{s.name}</Link>
            : <span className="text-xs px-2.5 py-1 rounded-full font-medium" style={st}>{s.name}</span>}
        </li>
      ))}
      {capped && (
        <li style={{ flex: '0 0 auto' }}>
          <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-svc-toggle
            className="text-xs px-2.5 py-1 rounded-full font-bold cursor-pointer"
            style={{ background: '#fff', color: '#1d4ed8', border: '1px solid #1d4ed8', minHeight: 30 }}>
            {open ? 'פחות' : `עוד ${items.length - cap!}`}
          </button>
        </li>
      )}
    </ul>
  );
}
